export default "__VITE_ASSET__2ufk6krA__"